export const PATHS = {
  HOME: {
    name: 'HOME',
    path: '/',
    label: 'checkout.paths.home',
    icon: 'mdi:ticket-confirmation-outline',
    available: true,
  },
  AUTH: {
    name: 'AUTH',
    path: '/auth',
    label: 'checkout.paths.auth',
    icon: 'ph:user',
    available: true,
  },
  ADDONS: {
    name: 'ADDONS',
    path: '/addons',
    label: 'checkout.paths.addons',
    icon: 'ph:shield-plus',
    available: true,
  },
  CUSTOMIZATION: {
    name: 'CUSTOMIZATION',
    path: '/customization',
    label: 'checkout.paths.customization',
    icon: 'material-symbols:edit-outline-rounded',
    available: true,
  },
  MERCH: {
    name: 'MERCH',
    path: '/merch',
    label: 'Envío',
    icon: 'mage:package-box',
    available: false,
  },
  PAYMENT: {
    name: 'PAYMENT',
    path: '/payment',
    label: 'checkout.paths.payment',
    icon: 'material-symbols:credit-card-outline',
    available: true,
  },
  SUCCESS: {
    name: 'SUCCESS',
    path: '/success',
    label: 'checkout.paths.success',
    icon: 'material-symbols:celebration',
    available: true,
  },
};

export const pathsOrder = [
  'HOME',
  'AUTH',
  'CUSTOMIZATION',
  'ADDONS',
  'MERCH',
  'PAYMENT',
  'SUCCESS',
];
